(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeDescriptionToggle = () => {
      document.querySelectorAll('[data-product-description]').forEach((root) => {
        if (root.dataset.productDescriptionInitialized === 'true') return;

        const content = root.querySelector('.product-description__content .text-block');
        const toggle = root.querySelector('[data-product-description-toggle]');

        if (!content || !toggle) return;

        root.dataset.productDescriptionInitialized = 'true';

        const refreshToggle = () => {
          if (root.dataset.expanded === 'true') return;

          toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = 'Read more';
        };

        toggle.addEventListener('click', () => {
          const isExpanded = root.dataset.expanded === 'true';
          root.dataset.expanded = isExpanded ? 'false' : 'true';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          toggle.textContent = isExpanded ? 'Read less' : 'Read more';

          if (isExpanded) {
            refreshToggle();
          }
        });

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(() => {
            if (root.dataset.expanded === 'false') {
              refreshToggle();
            }
          });

          resizeObserver.observe(content);
        }

        refreshToggle();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDescriptionToggle, { once: true });
    } else {
      initializeDescriptionToggle();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
